export const getLoanEasySteps = [
	{
		title: 'Оставьте заявку',
		content:
			'Заполните информацию о себе на сайте. Если возникнут вопросы, мы свяжемся с вами и поможем.',
	},
	{
		title: 'Ожидайте решения',
		content: 'Мы обрабатываем обращения и даём быстрый ответ в режиме онлайн.',
	},
	{
		title: 'Получите деньги',
		content: 'К вам уже спешит курьер с договором на подпись!',
	},
]
